import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { colors } from "../../../ui/colors";
import { Autocomplete } from "@react-google-maps/api";
import { useRef } from "react";
import { inputStyles } from "../../../ui/styles/inputStyles";
import { workAsIndividual, workIndustryIndividual } from "../constants/individual.constants";
import { PhoneInputWithFlags } from "../../../common/PhoneInputWithFlags";

export const PersonalInformationForm = ({ control, errors, setValue }) => {
  const autocompleteRef = useRef(null);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h6"
        sx={{
          mb: 3,
          color: colors.gray.base,
          fontWeight: 600,
          fontSize: { xs: "18px", md: "20px" },
        }}
      >
        Tell us about yourself - Just a few steps!
      </Typography>

      {/* Age + Phone */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 5 },
          mb: 4,
        }}
      >
        <Controller
          name="age"
          control={control}
          rules={{
            required: "Age is required",
            pattern: { value: /^[0-9]{1,2}$/, message: "Only up to 2 digits allowed" },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="Age"
              inputProps={{ inputMode: "numeric" }}
              error={!!errors.age}
              helperText={errors.age?.message}
              onChange={(e) => {
                let value = e.target.value.replace(/[^0-9]/g, "");
                if (value.length > 2) value = value.slice(0, 2);
                field.onChange(value);
              }}
              sx={inputStyles}
            />
          )}
        />


        <PhoneInputWithFlags setValue={setValue} control={control} errors={errors} required={false} />
      </Box>

      {/* Mailing Address */}
      <Box sx={{ mb: 4 }}>
        <Controller
          name="mailingAddress"
          control={control}
          rules={{ required: "Mailing address is required" }}
          render={({ field }) => (
            <Autocomplete
              onLoad={(autocomplete) => {
                autocompleteRef.current = autocomplete;
              }}
              onPlaceChanged={() => {
                if (autocompleteRef.current) {
                  const place = autocompleteRef.current.getPlace();
                  field.onChange(place.formatted_address || "");
                }
              }}
            >
              <TextField
                {...field}
                fullWidth
                label="Mailing Address"
                error={!!errors.mailingAddress}
                helperText={errors.mailingAddress?.message}
                sx={inputStyles}
              />
            </Autocomplete>
          )}
        />
      </Box>

      {/* Role + Industry */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 5 },
          mb: 2,
        }}
      >
        <Controller
          name="workAs"
          control={control}
          rules={{ required: "Please select your work" }}
          render={({ field }) => (
            <TextField
              {...field}
              select
              fullWidth
              label="You work as"
              error={!!errors.workAs}
              helperText={errors.workAs?.message}
              sx={inputStyles}
            >
              <MenuItem value="" disabled>
                Choose an option
              </MenuItem>
              {workAsIndividual.map((role) => (
                <MenuItem key={role} value={role}>
                  {role}
                </MenuItem>
              ))}
            </TextField>
          )}
        />

        <Controller
          name="individualIndustry"
          control={control}
          rules={{ required: "Please select your industry" }}
          render={({ field }) => (
            <TextField
              {...field}
              select
              fullWidth
              label="Your industry is"
              error={!!errors.individualIndustry}
              helperText={errors.individualIndustry?.message}
              sx={inputStyles}
            >
              <MenuItem value="" disabled>
                Choose an option
              </MenuItem>
              {workIndustryIndividual.map((structure) => (
                <MenuItem key={structure} value={structure}>
                  {structure}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Box>
    </Box>
  );
};
